<template>
  <v-container>
    <v-row>
      <v-col lg="12">
        <v-card class="card--shadow">
          <presumptive-list
            :township_id="$route.params.township_id"
            :presumptiveData="presumptiveData"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PresumptiveList from "@/components/presumptive/PresumptiveList.vue";
import { mapState } from "vuex";

export default {
  components: {
    PresumptiveList,
  },
  data: () => ({}),
  computed: {
    ...mapState("Presumptive", ["presumptiveData"]),
  },
  created() {
    this.$store.dispatch("Presumptive/getPresumptiveData");
  },
};
</script>
